/**
 * Control sticky behavior for primary product cards
 * Activates sticky AFTER card top (image) passes the header
 */

(function() {
  function initStickyBehavior() {
    // Only run on desktop
    if (window.innerWidth < 750) {
      return;
    }

    const primaryCardParents = document.querySelectorAll('.primary-product-card-parent');
    const header = document.querySelector('header-component, .header-section, header');
    
    if (!header || primaryCardParents.length === 0) {
      return;
    }

    // Store original positions
    const cardData = new Map();
    
    function storeCardPositions() {
      // Ensure we're at the top of the page for accurate measurements
      const currentScroll = window.pageYOffset || document.documentElement.scrollTop;
      
      primaryCardParents.forEach(cardParent => {
        // Temporarily remove sticky to get accurate static position
        const hadSticky = cardParent.classList.contains('sticky-active');
        cardParent.classList.remove('sticky-active');
        // Force a reflow to ensure position is recalculated
        void cardParent.offsetHeight;
        
        const rect = cardParent.getBoundingClientRect();
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
        // Calculate absolute position in document
        const originalTop = rect.top + scrollTop;
        const height = rect.height;
        
        cardData.set(cardParent, {
          originalTop: originalTop,
          height: height
        });
        
        // Restore sticky state if it was active
        if (hadSticky) {
          cardParent.classList.add('sticky-active');
        }
      });
    }
    
    storeCardPositions();

    function updateStickyState() {
      const headerHeight = header.offsetHeight || parseInt(getComputedStyle(document.body).getPropertyValue('--header-height')) || 0;
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      
      primaryCardParents.forEach(cardParent => {
        const data = cardData.get(cardParent);
        if (!data) return;
        
        const isCurrentlySticky = cardParent.classList.contains('sticky-active');
        
        // Calculate the scroll position where card top would touch header bottom
        // originalTop is where card starts in document
        // When we scroll to (originalTop - headerHeight), card top is at header bottom
        // We want sticky to activate when scrollTop >= this position
        const triggerPoint = data.originalTop - headerHeight;
        
        // Sticky activates AFTER the image passes the header
        // This happens when scrollTop >= triggerPoint
        const shouldBeSticky = scrollTop >= triggerPoint;
        
        if (shouldBeSticky && !isCurrentlySticky) {
          // Enable sticky - image has passed header
          cardParent.classList.add('sticky-active');
        } else if (!shouldBeSticky && isCurrentlySticky) {
          // Disable sticky - scrolling back up, image hasn't passed header yet
          cardParent.classList.remove('sticky-active');
        }
      });
    }

    // Initial check
    updateStickyState();

    // Update on scroll
    let ticking = false;
    window.addEventListener('scroll', () => {
      if (!ticking) {
        window.requestAnimationFrame(() => {
          updateStickyState();
          ticking = false;
        });
        ticking = true;
      }
    }, { passive: true });

    // Update on resize (recalculate positions)
    let resizeTimer;
    window.addEventListener('resize', () => {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(() => {
        if (window.innerWidth >= 750) {
          // Recalculate positions
          storeCardPositions();
          updateStickyState();
        } else {
          // Reset on mobile
          primaryCardParents.forEach(cardParent => {
            cardParent.classList.remove('sticky-active');
          });
        }
      }, 100);
    });

    // Watch for header height changes
    const headerObserver = new ResizeObserver(() => {
      updateStickyState();
    });
    
    if (header) {
      headerObserver.observe(header);
    }
  }

  // Run when DOM is ready
  function runInit() {
    // Wait for layout to settle and images to load
    setTimeout(() => {
      initStickyBehavior();
      // Re-run after a short delay to ensure all positions are accurate
      setTimeout(() => {
        const primaryCardParents = document.querySelectorAll('.primary-product-card-parent');
        if (primaryCardParents.length > 0) {
          initStickyBehavior();
        }
      }, 300);
    }, 200);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', runInit);
  } else {
    runInit();
  }

  // Also run when content is dynamically loaded
  if (document.addEventListener) {
    document.addEventListener('shopify:section:load', () => {
      setTimeout(initStickyBehavior, 200);
    });
    
    document.addEventListener('shopify:section:reorder', () => {
      setTimeout(initStickyBehavior, 200);
    });
  }
})();
